export abstract class PermissionsBaseModel {
  constructor(protected _permissions: string[]) {}

  protected checkAll(permissions: string[]): boolean {
    if (permissions && permissions.length > 0) {
      return permissions
        .map<boolean>((permission: string) =>
          this._permissions.some((userPermission: string) => permission === userPermission)
        )
        .reduce<boolean>((previousValue: boolean, currentValue: boolean) => previousValue && currentValue, true);
    }

    return false;
  }

  protected checkPermissions(permissions: string[]): boolean {
    if (permissions && permissions.length > 0) {
      return permissions.some((value: string) =>
        this._permissions.some((userPermission: string) => value === userPermission)
      );
    }

    return false;
  }

  public abstract get canView(): boolean;

  public abstract get canChange(): boolean;

  public abstract get canAdd(): boolean;

  public abstract get canDelete(): boolean;

  public abstract get isAdmin(): boolean;
}
